// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"587f9a20","122":"0ab4bddb","200":"c2dc32c4","271":"706aacb1","279":"e31427e8","397":"ccd35f2f","524":"91f799f5","675":"587f9a20","705":"f919e8bf","926":"3acf604e","983":"84f65939"}[chunkId] + ".chunk.css";
};